import React, { useEffect } from "react";
import { Box, Container, Paper, Typography, useTheme, useMediaQuery } from "@mui/material";
import AppShell from "./AppShell";
import usePageTitle from "../hooks/usePageTitle";

const PrivacyPolicy = () => {
  usePageTitle("Privacy Policy");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppShell>
      <Container maxWidth="md">
        <Box sx={{ p: isMobile ? 0 : 1 }}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
            <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}>
              Privacy Policy
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Your privacy is important to us. This policy explains how we collect, use, and safeguard your information.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: "bold" }}>
              Information We Collect
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              We may collect email addresses, usage data, and cookie information when you visit.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: "bold" }}>
              How We Use Your Information
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Collected data is used to improve our services, send updates, and for security purposes.
            </Typography>
          </Paper>
        </Box>
      </Container>
    </AppShell>
  );
};

export default PrivacyPolicy;
